import React from 'react';
import Button from '@mui/joy/Button';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { darkModeBackgroud } from '../../../../utils/constants';
import { useDarkModeStore } from '../../../../store/useDarkModeStore';

interface BackButtonProps {
    activeStep: number;
    goToPreviousStep: () => void;
}

const BackButton = ({ activeStep, goToPreviousStep }: BackButtonProps) => {
    const { darkMode } = useDarkModeStore();

    return <Button
        onClick={goToPreviousStep}
        disabled={activeStep === 0}
        variant="plain"
        sx={{
            color: darkMode ? 'white' : 'black',
            width: 50,
            '&:hover': { background: darkMode ? darkModeBackgroud : '#e3e3e6' }
        }}
    >
        <ArrowBackIcon sx={{ width: 25, height: 25 }} />
    </Button>
};

export default BackButton;